import { events } from 'core/events/eventEmitter';
import BaseEventHandler from 'core/events/eventHandler';
import review from './review';

export default class EventHandler extends BaseEventHandler {
  handlers: any;
  constructor() {
    super();
    this.handlers = [
      { event: events.REVIEW_INITIALIZED, instance: this.reviewInitialize.bind(this) },
      { event: events.COMMENT_SENT, instance: this.sendComment.bind(this) },
      { event: events.REVIEWER_AUTHORIZED, instance: this.userAuthorized.bind(this) },
      { event: events.REVIEW_RESTORE_USER, instance: this.restoreUser.bind(this) }
    ];
  }

  reviewInitialize({ reviewApiUrl, courseId, authoringToolDomain }: any) {
    review.initialize({ reviewApiUrl, courseId, authoringToolDomain });
  }

  sendComment({ data }: any) {
    return review.sendCommentRequest({ data });
  }

  userAuthorized({ name, email }: any) {
    review.storeUser({ name, email });
  }

  restoreUser() {
    return review.restoreUser();
  }
}
